import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionInfo } from '@omnipas/services/sessioninfo/sessioninfo';
import { AuthConfig, OAuthService, OAuthErrorEvent } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  initialized:           boolean = false;
  loading:               boolean = false;
  routerList:            any[];
  back:                  boolean = false;
  showdigitalcard:       boolean = false;
  showabout:             boolean = false;
  showmoreinfo:          boolean = false;
  showpermissionsinfo:   boolean = false;
  showphotorequirements: boolean = false;
  toosmall:              boolean = false;
  paying:                boolean = false;
  waittext:              string  = '';
  showwait:              boolean = false;
  timeleft:              number  = 500;
  interval;

  mainwidth:             number  = 0;
  mainheight:            number  = 0;

  constructor( public router: Router
             , public session: SessionInfo
             , public oauthService: OAuthService
             ) {
  }

  initialize() {
    if ( !this.initialized && !this.paying ) {
      this.routerList = [];
      this.initialized = true;
    }
  }

  requestPassword(){
    this.router.navigate(['/requestpassword']);
  }

  async goTo($link, clearToWelcome=false, clearAll=false ) {
    await this.toggleshowwait(true);

    if ( $link == 'welcome' || $link == 'error' || $link == 'logincheck' ) {
      this.initialized = false;
      this.initialize();
    } else if ( clearToWelcome ) {
      let index: number  = 0;
      let found: boolean = false;

      for ( let i = 0; i < this.routerList.length; i++ ) {
        if ( this.routerList[i] == 'welcome' ) {
          found = true;
          index = i;
          break;
        }
      }

      if ( found ) {
        this.routerList.splice(index+1);
      }
    }

    this.back = clearToWelcome;

    if ( $link != 'digitalcard' && $link != 'surflogin' && $link != 'adfslogin' && $link != 'saml' ) {
      this.routerList.push($link);
    }

    this.paying = $link == 'payment';

    this.router.navigate(['/'+$link]);
  }

  goHome() {
    this.back              = true;
    this.initialized       = false;
    this.paying            = false;
    this.initialize();
    this.showdigitalcard = false;
    this.router.navigate(['/welcome']);
  }

  goToLogin() {
    this.toggleshowwait(true);

    this.back        = true;
    this.initialized = false;
    this.paying      = false;
    this.initialize();

    this.router.navigate(['/']);
  }

  goBack() {
    this.toggleshowwait(true);

    this.back = true;
    this.routerList.splice(this.routerList.length-1, 1);
    this.paying = this.routerList[this.routerList.length-1] == 'payment';

    this.router.navigate(['/'+this.routerList[this.routerList.length-1]])
  }

  backTo($link) {
    this.toggleshowwait(true);

    this.back          = true;
    let index: number  = 0;
    let found: boolean = false;

    for ( let i = 0; i < this.routerList.length; i++ ) {
      if ( this.routerList[i] == $link ) {
        found = true;
        index = i;
        break;
      }
    }

    if ( found ) {
      this.routerList.splice(index+1);
    }

    this.paying = $link == 'payment';

    this.router.navigate(['/'+$link]);
  }

  logout() {
    this.toggleshowwait(true);

    this.session.loginID        = '';

    this.routerList = [];
    if ( this.session.useSurf && this.session.surfConfig['logoutUrl'] != undefined && this.session.surfConfig['logoutUrl'] != '' ) {
      //window.location.href = this.session.surfConfig['logoutUrl'];
      this.oauthService.logOut();
    } else {
      this.router.navigate(['/logout']);
    }

    this.toggleshowwait(false);
  }

  toggleshowwait( bool = false, text = 'loading.wait' ) {
    if ( bool ) {
      this.waittext = text;
    }
    this.showwait = bool;
  }

  starttimer() {
    if ( this.session.timeout > 0 ) {
      this.timeleft = this.session.timeout;

      this.interval = setInterval(() => {
        if(this.timeleft > 0) {
          this.timeleft--;
        } else {
          this.toggleshowwait(true);
          this.logout();
        }
      },1000)
    }
  }
}
